import React from 'react'
import { StyledCheckbox, CheckBoxProps } from './styled'

// TODO NewCheckboxに移行する
export const Checkbox: React.FC<CheckBoxProps> = (props: CheckBoxProps) => {
  return <StyledCheckbox {...props} />
}
